export const male_faces = [ //An array of each Male Face's ID, and Name. They use Atlas01. There are 9.
  {
    id: 'face7',
    name: 'Smiling'
  },
  {
    id: 'face5',
    name: 'Happy' //Show name in textbox.
  },
  {
    id: 'face8',
    name: 'Tired'
  },
  {
    id: 'face6',
    name: 'Sad'
  },
  {
    id: 'face4',
    name: 'Devilish'
  },
  {
    id: 'face1', 
    name: 'Dead', 
    disable: 'child' //No Dead face.
  },
  {
    id: 'face3',
    name: 'Childish'
  },
  {
    id: 'face2',
    name: 'Scared'
  },
  {
    id: 'feature15',
    name: 'Ghoulish'
  }
]